// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminFinances_wrapper__5agzQ","container":"AdminFinances_container__-p8U6"};